import { render, staticRenderFns } from "./manageOrganizations.vue?vue&type=template&id=0994d3ce&lang=pug"
import script from "./manageOrganizations.vue?vue&type=script&lang=js"
export * from "./manageOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports